import React, { useState, useEffect } from "react";
import Typing from "react-typing-animation";
import { PropagateLoader } from "react-spinners";
import Globe from "../../Components/Globe.js";

// import Particle from "../../Components/Particle";
import "./Skills.css";
import "../../loadingStyle.css";

export default function Skills() {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let timeoutId = setTimeout(() => {
      setLoading(false);
    }, 850);

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <div>
      {loading ? (
        <div className="loading">
          <PropagateLoader color="#F9880D" loading={loading} size={15} />
        </div>
      ) : (
        <div>
          {/* <Particle /> */}
          <div className="skills__content">
            <div className="skills__content__heading">
              <Typing
                cursorClassName="custom"
                cursor={<span>_</span>}
                speed={80}
              >
                <h1>Skills & Experience</h1>
              </Typing>
            </div>
            <div className="skills__content__content">
              <p>I'm a full stack web developer, familiar with :</p>
              <p>
                C++, HTML, CSS, JavaScript, Git, Nodejs, MongoDB, and Reactjs.
              </p>
              <p>I'm presently a Software Engineer, with prior internship</p>
              <p>experience as a MERN stack developer.</p>
            </div>
          </div>

          <div className="skills__cards">
            <Globe />
          </div>
        </div>
      )}
    </div>
  );
}
